import React, {useEffect, useState} from "react";
import { fetchCategories } from "../api/CategoryApi";
import { Link } from "react-router-dom";

function Categories() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCategories()
        .then((data) => {
            setCategories(data);
            setLoading(false);
        })
        .catch(() => setLoading(false));
    }, []);

    if (loading)
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );

    return(
        <main className="main-content">
            
            <section className="section">
                <div className="section-header">
                    <h2 className="section-title">Top categories</h2>
                </div>
                <div className="categories-grid">
                    {Array.isArray(categories) && categories.length > 0 ? (
                        categories.map((cat) => (
                            <Link to={`/apps/category/${cat.slug}`} key={cat.id} className="category-card" style={{textDecoration: "none"}}>
                                <div className="category-icon" style={{
                                    background: cat.color,
                                    backgroundImage: `url(${cat.icon_url})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    boxShadow: `0 0 0 2px ${cat.color}`
                                    }}>

                                </div>
                                <div className="category-name">{cat.name}</div>
                            </Link>
                            ))
                    ) : (
                        <p>No categories found.</p>
                    )}
                </div>
            </section>
            
        </main>
    );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // full page center
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

// Add global keyframes for spinner
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`,
  styleSheet.cssRules.length
);

export default Categories;